import { EventStructure } from "@ac-expo/api-types";
import { privateAxios } from "../axiosInstances";
import { useQuery } from "@tanstack/react-query";
import eventStructureQueryKeys from "../query-keys/event-structure.query-keys";

async function getEventStructure(eventId: string, structureId: string) {
  const { data } = await privateAxios.get<EventStructure>(
    `/event-structure/event/${eventId}/structure/${structureId}`
  );
  return data;
}

export const useGetEventStructureQuery = (
  eventId: string,
  structureId: string
) => {
  return useQuery({
    queryKey: eventStructureQueryKeys.get({ eventId, structureId }),
    queryFn: () => getEventStructure(eventId, structureId),
  });
};

async function getEventStructureById(id: string) {
  const { data } = await privateAxios.get<EventStructure>(
    `/event-structure/${id}`
  );
  return data;
}

export const useGetEventStructureByIdQuery = (id: string) => {
  return useQuery({
    queryKey: eventStructureQueryKeys.get({ id }),
    queryFn: () => getEventStructureById(id),
  });
};
